import React from "react";

interface GameStatusProps {
  gameWon: boolean;
  gameOver: boolean;
}

export const GameStatus: React.FC<GameStatusProps> = ({
  gameWon,
  gameOver,
}) => {
  if (gameWon) {
    return <div className="font-bold text-amber-300 text-lg">You won! 🎉</div>;
  }

  if (gameOver) {
    return <div className="font-bold text-rose-400 text-lg">Game over!</div>;
  }

  return null;
};

export default GameStatus;
